import "./style.css";

import Footer from "../../components/Footer/";
import Header from "../../components/Header/";

function Home() {
  return (
    <div>
      <Header
        sideBarItens={[
          {
            icone: "BiHome",
            titulo: "Home",
            link: "",
          },
          {
            icone: "BiCalendarCheck",
            titulo: "Iniciar simulado",
            link: "",
          },
          {
            icone: "BiChevronsLeft",
            titulo: "Item 3",
            link: "",
          },
        ]}
      />
      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architectoasuhdhuasdhuasuhdsahuu! Vero
        culpa inventore cumque nostrum quibusdam. Ab quaerat omnis ad labore
        voluptatem perspiciatis harum aliquid debitis cupiditate! Quibusdam
        libero dicta officia, quasi voluptatum perferendis eius odio cupiditate,
        eveniet aperiam eum, amet recusandae quia? Ex similique velit rem ipsa!
        Eaque.{" "}
      </p>
      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architecto! Vero culpa inventore cumque
        nostrum quibusdam. Ab quaerat omnis ad labore voluptatem perspiciatis
        harum aliquid debitis cupiditate! Quibusdam libero dicta officia, quasi
        voluptatum perferendis eius odio cupiditate, eveniet aperiam eum, amet
        recusandae quia? Ex similique velit rem ipsa! Eaque.{" "}
      </p>
      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architecto! Vero culpa inventore cumque
        nostrum quibusdam. Ab quaerat omnis ad labore voluptatem perspiciatis
        harum aliquid debitis cupiditate! Quibusdam libero dicta officia, quasi
        voluptatum perferendis eius odio cupiditate, eveniet aperiam eum, amet
        recusandae quia? Ex similique velit rem ipsa! Eaque.{" "}
      </p>
      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architecto! Vero culpa inventore cumque
        nostrum quibusdam. Ab quaerat omnis ad labore voluptatem perspiciatis
        harum aliquid debitis cupiditate! Quibusdam libero dicta officia, quasi
        voluptatum perferendis eius odio cupiditate, eveniet aperiam eum, amet
        recusandae quia? Ex similique velit rem ipsa! Eaque.{" "}
      </p>

      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architecto! Vero culpa inventore cumque
        nostrum quibusdam. Ab quaerat omnis ad labore voluptatem perspiciatis
        harum aliquid debitis cupiditate! Quibusdam libero dicta officia, quasi
        voluptatum perferendis eius odio cupiditate, eveniet aperiam eum, amet
        recusandae quia? Ex similique velit rem ipsa! Eaque.{" "}
      </p>
      <p>
        {" "}
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Repudiandae
        officia beatae nesciunt voluptas debitis? Maiores aliquam, placeat
        distinctio vero tenetur earum temporibus quam in similique facilis
        molestias reiciendis magni recusandae excepturi beatae sunt repudiandae
        delectus atque velit soluta doloribus enim repellat molestiae optio.
        Mollitia harum, voluptate accusamus delectus deserunt possimus
        inventore, voluptatem reiciendis totam, consequuntur repellat! Animi
        molestiae ratione cupiditate vero officiis laboriosam vel consequatur,
        vitae aperiam, quis ut quae suscipit et odit quibusdam maiores molestias
        velit, nesciunt enim adipisci architecto! Vero culpa inventore cumque
        nostrum quibusdam. Ab quaerat omnis ad labore voluptatem perspiciatis
        harum aliquid debitis cupiditate! Quibusdam libero dicta officia, quasi
        voluptatum perferendis eius odio cupiditate, eveniet aperiam eum, amet
        recusandae quia? Ex similique velit rem ipsa! Eaque.{" "}
      </p>

      <Footer />
    </div>
  );
}

export default Home;
